/**
 * Autoplay fiable de los vídeos del slideshow (hero) en móvil.
 *
 * El tema llama a play() cuando el vídeo entra en pantalla. Si el navegador lo
 * rechaza (iOS con ahorro de batería, Safari antes de un gesto, etc.) el tema
 * muestra los controles nativos y el visitante tiene que pulsar play.
 * Aquí se fuerza muted + playsinline, se quitan los controles y se reintenta
 * al cargar, al volver a la pestaña y en el primer gesto del visitante.
 * Si el visitante activa el sonido con el botón del hero, no se vuelve a silenciar.
 */
(function () {
  var SELECTOR = '.slideshow video';

  function prepare(video) {
    if (video.dataset.heroAutoplay) return;
    video.dataset.heroAutoplay = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
  }

  function hideControls(video) {
    video.controls = false;
    video.removeAttribute('controls');
    var host = video.closest('video-media');
    if (host) host.removeAttribute('suspended');
  }

  function play(video) {
    if (!video.offsetParent || !video.paused) return;
    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {}).then(function () {
        window.setTimeout(function () { hideControls(video); }, 0);
      });
    }
  }

  function setup(video) {
    prepare(video);
    hideControls(video);
    ['loadeddata', 'canplay'].forEach(function (name) {
      video.addEventListener(name, function () { play(video); });
    });
    play(video);
  }

  /* Solo el slide visible: los demás siguen pausados por el carrusel */
  function playAll() {
    document.querySelectorAll('.slideshow__slide.is-selected video').forEach(play);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) playAll();
    });
    ['touchstart', 'pointerdown', 'scroll', 'click'].forEach(function (name) {
      window.addEventListener(name, playAll, { once: true, passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
